import { HttpErrorResponse } from '@angular/common/http';
import { ResourceErrorType } from './resource-error.component';

/**
 * Map a failed API response to a user-facing {@link ResourceErrorType}.
 *
 * - 404 -> `not-found` (the enrollment/lesson doesn't exist)
 * - 403 -> `forbidden` (the user can't access this specific record)
 * - 400 -> `invalid`   (the id, or combination of ids, was rejected as malformed)
 * - anything else -> `error`
 */
export function toResourceErrorType(error: unknown): ResourceErrorType {
	if (error instanceof HttpErrorResponse) {
		switch (error.status) {
			case 404:
				return 'not-found';
			case 403:
				return 'forbidden';
			case 400:
				return 'invalid';
		}
	}

	return 'error';
}
